module.exports = __webpack_public_path__ + "static/media/mr-dedepyaarde.9e46b97d.png";